import { render, staticRenderFns } from "./naver.vue?vue&type=template&id=881800c0"
import script from "./naver.vue?vue&type=script&lang=js"
export * from "./naver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../production-parity-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports